import axiosapi from "./axiosAPI";

// Get All Districts
export const getAllDistricts = async (
    setDistricts,
    setFetcherror

) => {
    
    
	try{
		const res =await axiosapi.get("/districts");
        setDistricts(res.data.data ? res.data.data : {});

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Districts");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Districts");
		}
		
	}
	
};

// Get All Districts per Region
export const getRegionDistricts = async (
    setDistricts,
    setFetcherror,
    pkid
) => {
    
    
	try{
		const res =await axiosapi.get(`/regiondistricts/${pkid}`);
        setDistricts(res.data.data ? res.data.data : {});

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Districts");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Districts");
		}
		
	}
	
};



// Get One District
export const getOneDistrict = async (
    pkid,
    setFetcherror,  
    setDistrict
    
)=>{
	try{
		const res =await axiosapi.get(`/districts/${pkid}`);
        setDistrict(res.data.body);
       
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch District");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch District");
		}
		
	}
	
};


// Create New District
export const createDistrict = async (
    district,
    region_id,
    setDistrict,
    setFetcherror,
    handleAllToasts,
    setDistricts

) => {

    if (!district ) {
        handleAllToasts(2, "No District Provided"); 
            return; 
        }

    const PushItem = {
        name: district,
        region_id:region_id
        };

    try{
        await axiosapi.post("/districts/",PushItem );
        setDistrict("");
        handleAllToasts(1, "District Created Successfully");
        getAllDistricts(setDistricts,setFetcherror);
    }
    catch(err){
        if(err.response){
            //Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Could Not Create New District");
            handleAllToasts(2, "Could Not update The District");
            
            
        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Could Not Create New District");
            handleAllToasts(2, "Could Not update The District");
            
        }
        
    }
    
}


// Edit Existing District

export const editDistrict = async (
    districtpkid,
    editedDistrict,
    setEditedDistrict,
    selectedEditedRegion,
    setSelectedEditedRegion,
    setFetcherror,
    handleAllToasts,
    setDistricts
              
        ) => {

            if (!editedDistrict) {
                handleAllToasts(2, "No District Name Provided"); 
                    return;  
                }

            const PushItem = {

                    id:districtpkid,
                    name: editedDistrict,
                    region_id:selectedEditedRegion?.id
                };

            try{
                await axiosapi.patch("/districts/",PushItem );
                setEditedDistrict("");
                setSelectedEditedRegion("");
                handleAllToasts(1, "District Updated Successfully");
                getAllDistricts(setDistricts,setFetcherror);
            }
            catch(err){
                if(err.response){
                    //Error Obtained from Backend not in 200
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                    setFetcherror("Could Not Update District");
                    handleAllToasts(2, "Could Not Update District");
                    
                    
                }else{
                    //No response Obtained from the server.
                    console.log(`Error: ${err.message}`);
                    setFetcherror("Could Not Update District");
                    handleAllToasts(2, "Could Not Update District");
                    
                }
                
            }
            
};



// Delete Existing District.

export const deleteDistrict = async (
    districtpkid,
    setcountries,
    setFetcherror,
    handleAllToasts,
    setDistricts
)=>{
    try {
        const res = await axiosapi.delete(`/districts/${districtpkid}`);
        let finalData = res.data.message;
        getAllDistricts(setcountries, setFetcherror);
        handleAllToasts(1, "District Deleted Successfully");
        console.log("Deleted:", finalData);
        getAllDistricts(setDistricts,setFetcherror);
    }
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
			console.log(err.response.data);
			console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete District");
            handleAllToasts(2,"Error: Could Not Delete District");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete District");
            handleAllToasts(2,"Error: Could Not Delete District");
		}
		
	}
	
};